// extracted by mini-css-extract-plugin
module.exports = {"dashedButton":"tu9mfGxp"};